import callbackRouterPaths from './callbackRouterPaths';

export default callbackRouterPaths;
